/**
 * @file index.js
 * @author Fernando Ruano
 * @description Initialize CountryUserRoles View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './countryUserRolesViewEdit';

/**
 * Map state to props
 * @returns { object }
 */
export const mapStateToPropsCURViewEdit = mapStateToProps;
export const mapDispatchToPropsCURViewEdit = mapDispatchToProps;

export default connect(
  mapStateToPropsCURViewEdit,
  mapDispatchToPropsCURViewEdit
)(View);
